// Third-party script performance optimizer
(function() {
    'use strict';
    
    // Configuration for script loading
    const scriptConfig = {
      // Scripts that should be loaded immediately
      critical: [
        'https://www.googletagmanager.com/gtm.js'
      ],
      
      // Scripts that should be loaded after page load
      deferred: [
        'https://www.google-analytics.com/analytics.js',
        'https://connect.facebook.net/en_US/fbevents.js'
      ],
      
      // Scripts that should be loaded on user interaction
      lazy: [
        'https://static.klaviyo.com/onsite/js/klaviyo.js',
        'https://business-api.tiktok.com/static/js/tiktok-pixel.js'
      ]
    };
  
    // Performance monitoring
    const performance = {
      startTime: Date.now(),
      metrics: {},
      
      mark: function(name) {
        this.metrics[name] = Date.now() - this.startTime;
        if (window.performance && window.performance.mark) {
          window.performance.mark(name);
        }
      },
      
      measure: function(name, startMark, endMark) {
        if (window.performance && window.performance.measure) {
          window.performance.measure(name, startMark, endMark);
        }
      }
    };
  
    // Script loader with performance tracking
    const scriptLoader = {
      loadScript: function(src, options = {}) {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.async = options.async !== false;
          script.defer = options.defer || false;
          
          if (options.integrity) {
            script.integrity = options.integrity;
          }
          if (options.crossOrigin) {
            script.crossOrigin = options.crossOrigin;
          }
          
          script.onload = () => {
            performance.mark(`script-loaded-${src}`);
            resolve(script);
          };
          
          script.onerror = () => {
            console.warn(`Failed to load script: ${src}`);
            reject(new Error(`Script load failed: ${src}`));
          };
          
          performance.mark(`script-start-${src}`);
          document.head.appendChild(script);
        });
      },
      
      loadCritical: function() {
        return Promise.all(
          scriptConfig.critical.map(src => 
            this.loadScript(src, { async: true })
          )
        );
      },
      
      loadDeferred: function() {
        // Load deferred scripts after page load
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => {
              scriptConfig.deferred.forEach(src => {
                this.loadScript(src, { async: true });
              });
            }, 1000);
          });
        } else {
          setTimeout(() => {
            scriptConfig.deferred.forEach(src => {
              this.loadScript(src, { async: true });
            });
          }, 1000);
        }
      },
      
      loadLazy: function() {
        // Load lazy scripts on user interaction
        const loadLazyScripts = () => {
          scriptConfig.lazy.forEach(src => {
            this.loadScript(src, { async: true });
          });
          // Remove event listeners after loading
          document.removeEventListener('scroll', loadLazyScripts);
          document.removeEventListener('mousemove', loadLazyScripts);
          document.removeEventListener('click', loadLazyScripts);
        };
        
        document.addEventListener('scroll', loadLazyScripts, { passive: true });
        document.addEventListener('mousemove', loadLazyScripts, { passive: true });
        document.addEventListener('click', loadLazyScripts, { passive: true });
      }
    };
  
    // Resource hints optimizer
    const resourceHints = {
      addPreconnect: function(domain) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = domain;
        document.head.appendChild(link);
      },
      
      addDnsPrefetch: function(domain) {
        const link = document.createElement('link');
        link.rel = 'dns-prefetch';
        link.href = domain;
        document.head.appendChild(link);
      },
      
      addPreload: function(resource, type) {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.href = resource;
        link.as = type;
        document.head.appendChild(link);
      }
    };
  
    // Initialize performance optimization
    const init = () => {
      performance.mark('optimization-start');
      
      // Add resource hints for common third-party domains
      const domains = [
        'https://www.googletagmanager.com',
        'https://www.google-analytics.com',
        'https://connect.facebook.net',
        'https://static.klaviyo.com',
        'https://business-api.tiktok.com'
      ];
      
      domains.forEach(domain => {
        resourceHints.addPreconnect(domain);
        resourceHints.addDnsPrefetch(domain);
      });
      
      // Load critical scripts
      scriptLoader.loadCritical().then(() => {
        performance.mark('critical-scripts-loaded');
      }).catch(error => {
        console.warn('Critical script loading failed:', error);
      });
      
      // Setup deferred and lazy loading
      scriptLoader.loadDeferred();
      scriptLoader.loadLazy();
      
      performance.mark('optimization-complete');
    };
  
    // Start optimization when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  
    // Expose performance metrics for debugging
    window.scriptPerformance = performance;
    
  })();